import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import withBaseLayout from '../../components/BaseLayout/withBaseLayout.js';
import PageHeading from '../../components/PageHeading/PageHeading.js';
import BackLink from '../../components/BackLink/BackLink';
import CardSpacer from '../../components/CardSpacer/CardSpacer';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'services';

class ProfileChildLayout extends React.Component {
  render() {
    const { classes, title, summary, summary2, backAction, section } =
      this.props;

    return (
      <div className={`${classes.root} PageLayout`}>
        <BackLink action={backAction} />
        <PageHeading heading={title} />
        {summary && (
          <Typography
            className={classes.summary}
            dangerouslySetInnerHTML={{ __html: summary }}
          ></Typography>
        )}
        {summary2 && (
          <React.Fragment>
            <br />
            <Typography
              className={classes.summary}
              dangerouslySetInnerHTML={{ __html: summary2 }}
            ></Typography>
          </React.Fragment>
        )}
        <CardSpacer />
        <Grid container spacing={24} className="DashGridContainer">
          <Grid item xs={12} className={`${classes.gridItem} DashGridColumn`}>
            {section}
          </Grid>
        </Grid>
        <BackLink action={backAction} gutterTop={true} />
      </div>
    );
  }
}

ProfileChildLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  summary2: PropTypes.string,
  backAction: PropTypes.func.isRequired,
  section: PropTypes.object,
};

ProfileChildLayout.defaultProps = {
  summary: null,
  summary2: null,
};

export default withBaseLayout(withStyles(styles)(ProfileChildLayout));
